import * as React from "react";
import * as styles from "./styles";

interface IProps {
  placeholder?: string;
  value: string;
  type?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  id?: string;
  style?: any;
  inputRef?: (c: HTMLInputElement) => void;
}

const Input: React.FunctionComponent<IProps> = ({
  value,
  placeholder,
  type,
  disabled,
  onChange,
  id,
  inputRef,
  style
}) => (
  <div className={styles.input} style={style}>
    <input
      ref={inputRef}
      id={id}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      type={type}
      disabled={disabled}
    />
  </div>
);

Input.defaultProps = {
  type: "text",
  disabled: false,
  placeholder: ""
};

export default Input;

interface ILabelProps {
  id: string;
  label: JSX.Element;
}

export const LabeledInput: React.FunctionComponent<IProps & ILabelProps> = ({
  id,
  value,
  type,
  disabled,
  onChange,
  label,
  placeholder
}) => (
  <div className={styles.labeledInput}>
    <label htmlFor={id}>{label}</label>
    <Input
      id={id}
      placeholder={placeholder}
      value={value}
      type={type}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);
